var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 17.638 25.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3,6.675a.753.753,0,0,0-1.4.389,1.667,1.667,0,0,1-3.333,0V.753A.753.753,0,0,0,8.287.221,36.821,36.821,0,0,0,4.16,5.377a29.247,29.247,0,0,0-2.845,5.305A16.813,16.813,0,0,0,0,16.885a8.819,8.819,0,0,0,17.638,0C17.638,13.772,16.516,10.337,14.3,6.675Zm-.459,10.014a.753.753,0,0,1-1.506,0V15.281l-3.75,3.75a.753.753,0,0,1-1.065,0L5.774,17.282,4.6,18.46A.753.753,0,1,1,3.531,17.4l1.711-1.711a.753.753,0,0,1,1.065,0l1.749,1.749,3.217-3.217H9.864a.753.753,0,1,1,0-1.506h3.227a.753.753,0,0,1,.753.753v3.226Zm0,0",
    fill: "#268AF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendBlue);
export default __webpack_public_path__ + "static/media/trendBlue.17570bd68d643e85d1fa97a21ea8dcc1.svg";
export { ForwardRef as ReactComponent };